import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const WebViewPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState("checking");

  const location = useLocation();

  // Reset animation state on route change
  useEffect(() => {
    setIsLoaded(false);
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Basic connection check
  useEffect(() => {
    const checkConnection = async () => {
      try {
        setConnectionStatus("connected");
      } catch (error) {
        setConnectionStatus("error");
      }
    };
    checkConnection();
  }, []);

  const handleRefresh = () => {
    const iframe = document.getElementById("external-webview");
    if (iframe) {
      iframe.src = iframe.src;
    }
  };

  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden">
      <div className="flex-grow overflow-hidden px-2 md:px-4 py-3">
        <div
          className={`bg-white bg-opacity-60 dark:bg-white dark:bg-opacity-10 rounded-lg h-full flex flex-col transition-all duration-500 ${
            isLoaded ? "opacity-100" : "opacity-0"
          }`}
        >
          {/* WebView Container */}
          <div
            className={`flex-1 bg-white dark:bg-laryzeDarkGray dark:bg-opacity-90 rounded-lg shadow mx-4 mb-4 border-t-8 border-t-black dark:border-t-uasYellow overflow-hidden transition-all duration-500 delay-200 ${
              isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            {connectionStatus === "error" ? (
              <div className="flex items-center justify-center h-full text-center p-8">
                <div className="max-w-md">
                  <svg
                    className="w-16 h-16 mx-auto text-red-500 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    Unable to Connect
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 mb-4">
                    Could not load the external application at
                    http://10.5.30.50:3013/
                  </p>
                  <button
                    onClick={handleRefresh}
                    className="px-4 py-2 bg-black dark:bg-uasYellow dark:text-black text-white rounded hover:bg-gray-800 dark:hover:bg-yellow-400 transition-colors"
                  >
                    Try Again
                  </button>
                </div>
              </div>
            ) : (
              <iframe
                id="external-webview"
                src="http://10.5.30.50:3013/"
                className="w-full h-full border-none"
                title="External Application"
                onLoad={() => setConnectionStatus("connected")}
                onError={() => setConnectionStatus("error")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebViewPage;
